import { render } from "./HeroiconsSolidExclamationCircle.vue?vue&type=template&id=0b6d02f0"
const script = {}

import exportComponent from "/Users/hamid/Nova/onsho24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidExclamationCircle.vue"]])

export default __exports__